function isRecord(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function assertKnownPageSignalPatchRoots(
  pageId,
  signals,
  patch,
  { permittedRoots = null } = {},
) {
  if (!isRecord(signals) || !isRecord(patch)) {
    throw new TypeError(`${pageId} signal patches require record-shaped signals and patch`);
  }
  if (permittedRoots !== null && !(permittedRoots instanceof Set)) {
    throw new TypeError(`${pageId} permitted signal roots require a Set`);
  }
  const unknownRoots = Object.keys(patch).filter((root) => (
    !Object.hasOwn(signals, root) && !permittedRoots?.has(root)
  ));
  if (unknownRoots.length > 0) {
    throw new TypeError(
      `${pageId} signal patch contains undeclared top-level roots: ${unknownRoots.join(", ")}`,
    );
  }
  return patch;
}
